import {
  DragEndEvent,
  Over,
  UniqueIdentifier,
  useDndMonitor,
  useDroppable,
  UseDroppableArguments,
} from '@dnd-kit/core';
import { cloneElement, FC, isValidElement, ReactElement } from 'react';

export interface DragEndEventWithOver extends DragEndEvent {
  over: Over;
}

const isDragEndEventOverSelf = (
  event: DragEndEvent,
  id: UniqueIdentifier
): event is DragEndEventWithOver => {
  return event.over?.id === id;
};

export type TProps = {
  children?: ReactElement<any>;
  onDrop?: (event: DragEndEventWithOver) => void;
} & Pick<UseDroppableArguments, 'id' | 'data' | 'disabled'>;

const Droppable: FC<TProps> = (props) => {
  const { id, children, data, disabled, onDrop } = props;

  useDndMonitor({
    onDragEnd(event) {
      if (isDragEndEventOverSelf(event, id)) {
        onDrop?.(event);
      }
    },
  });

  const { isOver, setNodeRef } = useDroppable({
    id,
    data,
    disabled,
  });

  if (!children || !isValidElement(children)) {
    console.error(
      'Droppable component requires a single valid React element as a child.'
    );
    return children;
  }

  const DroppableChild = children;

  return cloneElement(DroppableChild, {
    // @ts-expect-error: ref is not typed at this point
    ref: setNodeRef,
    'data-over': isOver || undefined,
  });
};

export default Droppable;
